import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import discussion2image1 from '../../documents/discussion2image1.JPG'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Discussion2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            discussion2Key: ['	Effect of slag cement on thermal performance of bridge decks',
            'Effect of environmental conditions on thermal performance',
            '	Effect of structural loads on cracking behavior','Effect of dead load on thermal behaviour','	Regime of traffic on cracking behaviour '],
            discussion2Value: ['	Critical Review-Technical Writing', 'Engineering Judgment'],
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Discussion of “Thermally Induced Behavior of Paired Internally Cured Concrete and Conventional Concrete Decks in Composite Bridges” by Waleed K. Hamid, Eric P.Steinberg, Issam Khoury, Ali A. Semendary, and Kenneth Walsh</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'> 
                        Duration: May 2021 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiText>
                        <b>Key Highlights</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.discussion2Key && this.state.discussion2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.discussion2Value && this.state.discussion2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><EuiFlexItem grow={false}><EuiText textAlign='center'><EuiImage style={{width: '25vw',height: '25vw'}} src={discussion2image1} /><EuiSpacer size = 's'/></EuiText></EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Discussion2 }